/**
 * A list of languages currently supported by Snap Habit
 */
export enum LanguageCode {
  EN = "en",
  JA = "ja",
  ZH_HANS = "zh-Hans",
  ZH_HANT = "zh-Hant",
}
